import axiosInsAcademy from '@/api/axios-ugems-academy';

const baseUrl = '/tna/partner/subcon-mappings';

export default {
  getAll(params) {
    return axiosInsAcademy.get(baseUrl, { params });
  },
  getCompanyOptions(params) {
    return axiosInsAcademy.get(`${baseUrl}/company-options`, { params });
  },
  getById(id) {
    return axiosInsAcademy.get(`${baseUrl}/${id}`);
  },
  create(payload) {
    return axiosInsAcademy.post(baseUrl, payload);
  },
  update(id, payload) {
    return axiosInsAcademy.put(`${baseUrl}/${id}`, payload);
  },
  setStatus(id, isActive) {
    return axiosInsAcademy.patch(`${baseUrl}/${id}/status`, { is_active: isActive });
  },
  delete(id) {
    return axiosInsAcademy.delete(`${baseUrl}/${id}`);
  }
};
